import React, { useState } from 'react';

const Subscription = () => {
  // State to track the current plan
  const [currentPlan, setCurrentPlan] = useState('free');

  // Define the subscription plans
  const plans = [
    {
      id: 'free',
      name: 'Free Tier',
      price: 'CA $0.00/mo',
      features: [
        { text: '1 Child Profile', available: true },
        { text: 'Limited Platforms (Discord only)', available: true },
        { text: '1 real-time alert per day', available: true },
        { text: 'Last 7 days alert history', available: true },
        { text: 'Blacklist users', available: false },
        { text: 'Notify authorities', available: false }
      ],
      buttonText: 'Current Plan',
      buttonAction: () => console.log('Already on Free Tier')
    },
    {
      id: 'basic',
      name: 'Basic Plan',
      price: 'CA $9.99/mo',
      features: [
        { text: 'Up to 3 children', available: true },
        { text: '3 Platforms (Discord, TikTok, Snap)', available: true },
        { text: 'Unlimited real-time alerts', available: true },
        { text: '30-day alert history', available: true },
        { text: 'Blacklist users', available: true },
        { text: 'Manual authority notification', available: true }
      ],
      buttonText: 'Upgrade Plan',
      buttonAction: () => console.log('Upgrading to Basic Plan')
    },
    {
      id: 'premium',
      name: 'Premium Plan',
      price: 'CA $19.99/mo',
      features: [
        { text: 'Up to 6 children', available: true },
        { text: 'All supported platforms', available: true },
        { text: 'Priority alerts + detailed summary', available: true },
        { text: 'Full history with download option', available: true },
        { text: 'AI-suggested blocklists', available: true },
        { text: 'Auto-notify through SMS and email', available: true }
      ],
      buttonText: 'Upgrade to Premium',
      buttonAction: () => console.log('Upgrading to Premium Plan')
    }
  ];

  // Handle plan selection
  const handlePlanSelection = (planId) => {
    console.log(`Selected plan: ${planId}`);
    
  };

  return (
    <div className="content-container">
      <h1 className="page-title">Subscription</h1>
      <p className="page-subtitle">Choose the right subscription plan for your family!</p>

      <div className="subscription-plans-container">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`subscription-plan-card plan-${plan.id} ${currentPlan === plan.id ? 'current-plan' : ''}`}
          >
            <div className="plan-header">
              <h2 className="plan-name">{plan.name}</h2>
              <div className="plan-price">{plan.price}</div>
            </div>

            <div className="plan-features">
              {plan.features.map((feature, index) => (
                <div key={index} className="feature-item">
                  {feature.available ? (
                    <span className="feature-available">✓</span>
                  ) : (
                    <span className="feature-unavailable">✕</span>
                  )}
                  <span className="feature-text">{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="plan-action">
              <button 
                className={`plan-button ${currentPlan === plan.id ? 'current-button' : ''}`}
                onClick={() => handlePlanSelection(plan.id)}
                disabled={currentPlan === plan.id}
              >
                {plan.buttonText}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Subscription;